import { render, staticRenderFns } from "./shijianxuanze.vue?vue&type=template&id=1ebffd74&scoped=true"
import script from "./shijianxuanze.vue?vue&type=script&lang=js"
export * from "./shijianxuanze.vue?vue&type=script&lang=js"
import style0 from "./shijianxuanze.vue?vue&type=style&index=0&id=1ebffd74&prod&lang=css"
import style1 from "./shijianxuanze.vue?vue&type=style&index=1&id=1ebffd74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebffd74",
  null
  
)

export default component.exports